<script lang="ts">
  import SectionCheckEmitedList from '@/generated/sections/SectionCheckEmitedList.vue';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import Transaction from '@/extend/classes/Transaction';
  import Section from '@/framework/base/classes/Section';
  import { TransactionTypes, TransactionStatuts } from '@/generated/classes/Transaction';
  import { defineComponent } from "vue";

  export default defineComponent({
    components: {},
    extends: SectionCheckEmitedList,
    computed: {
      headers () {
        return [
          { text: "Date d'émission", value: 'dateProcess', cellClass: '', sortable: true },
          { text: "Destinataire", value: 'ownerLabel', cellClass: '', sortable: true },
          { text: "Numéro", value: 'reference', cellClass: '', sortable: true },
          { text: "Montant", value: 'amount', cellClass: '', sortable: true },
          { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
        ];
      },
      canAdd (): boolean {
        return false;
      }
    },
    methods: {
      canUpdate (transaction: Transaction): boolean {
        return false;
      },
      defaultFilter (): void {
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionTypes.CHEQUE_EMIS;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "statut";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionStatuts.EMITTED;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
      },
      mdiAction (transaction: Transaction): string {
        return 'fas fa-landmark';
      },
      hasAction (transaction: Transaction): boolean {
        return transaction.bankId == 0;
      },
      execAction (transaction: Transaction): void {
        this.actionProgress = true;
        Transaction.simuBank([transaction]).then((res) => {
          this.actionProgress = false;
        }).catch(() => {
          this.actionProgress = false;
        });
      }
    }
  })

</script>
